import React from "react";

export const ArrowheadUp: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M5.00005 0L9.5 12H0.5L5.00005 0Z" fill="#006747" />
    </svg>
  );
};
